// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Zemo Bank */
export const ZemoBank = createBankIcon({
  name: "Zemo Bank",
  slug: "zemobank",
  compe: null,
  color: "#001041",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#001041;fill-opacity:1\"\n     id=\"zemobank_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0154,21.0155) scale(0.02320)\">\n    <path d=\"M 1334.17,1526.85 l 567.34,0 l 0,396.07 L 536.2,1922.92 l 635.47,-949.79 l -548.86,0 l 0,-396.07 l 1341,0 l -629.63,949.79 Z\" style=\"fill:#ffffff\" />\n    <path d=\"M 1002.19,2500 l 495.33,0 l -103.15,-415.53 l -290,0 l -102.18,415.53 Z\" style=\"fill:#1089ff\" />\n    <path d=\"M 1497.55,0 l -495.33,0 l 102.18,416.51 l 290,0 L 1497.55,0 Z\" style=\"fill:#1089ff\" />\n  </g>",
});
